<template>
  <div class="login">
    <h1 class="h1 mt0 mb60">{{$route.meta.title}}</h1>
    <div class="login__card bg-gray">
      <h3 class="card__title mt0 mb30">Вход администратора</h3>
      <form class="pt10 pb10">
        <InputText :name="'email'"
                   :error="errors.first('email')"
                   :placeholder="'Логин'"
                   v-validate="'required'"
                   v-model="value['email']"
        />
        <InputText :name="'password'"
                   :error="errors.first('password')"
                   :placeholder="'Пароль'"
                   :type="'password'"
                   v-validate="'required'"
                   v-model="value['password']"
        />
        <CustopButton class="btn btn--blue width100" @click="enter">
          Войти
        </CustopButton>
      </form>
      <div class="login__error" v-if="error">
        <svg width="13" height="13">
          <use xlink:href="/img/x.svg#x"></use>
        </svg>
        <span class="ml10">Логин или пароль введены неверно</span>
      </div>
    </div>
  </div>
</template>

<script>
  import InputText from "../components/inputs/InputText";
  import CustopButton from "../components/CustomButton";

  export default {
    name: "Login",
    components: {CustopButton, InputText},
    data() {
      return {
        value: {},
        error: false
      }
    },
    methods: {
      enter() {
        this.$validator.validateAll()
          .then(answer => {
            if (answer) {
              this.$store.dispatch('user/AUTH', {user: this.value})
                .then(res => {
                  if (res.ok) {
                    this.$router.push({name: 'menu'});
                  }
                  else {
                    this.error = true;
                  }
                })
            }
          });
      }
    },
  }
</script>

<style lang="scss">
  @import "../style/var";
  .login {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 0 50px;
    text-align: center;
    &__error {
      margin-top: 20px;
      margin-left: -50px;
      width: calc(100% + 80px);
      svg {
        fill: #EC3636;
      }
    }
    &__card {
      width: 385px;
      max-width: 100%;
      padding: 45px 78px 40px;
      text-align: center;
      @media (max-width: 575px) {
        padding: 45px 54px 40px;
        width: 334px;
      }
    }
  }
</style>